import { Box, Card, CircularProgress } from "@mui/material";
import { styled } from "@mui/material/styles";
import { colors } from "@zapalacorp/tokens";

export const StyledCard = styled(Card)(({ theme }) => ({
  marginBottom: theme.spacing(2),
  border: `1px solid ${colors.gray200}`,
  borderRadius: theme.spacing(1),
  maxWidth: "100%",
  boxSizing: "border-box",
}));

export const GroupHeader = styled(Box)(({ theme }) => ({
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  marginBottom: theme.spacing(2),
  gap: theme.spacing(2),
  minWidth: 0,
  "& > *:first-of-type": { minWidth: 0, overflow: "hidden" },
}));

export const SettingsSection = styled(Box)(({ theme }) => ({
  marginTop: theme.spacing(2),
  paddingTop: theme.spacing(2),
  borderTop: `1px solid ${theme.palette.divider}`,
}));

export const Loading = styled(CircularProgress)(() => ({
  marginRight: "10px",
  color: colors.gray400,
}));

export const Title = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 700,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
}));

export const SubTitle = styled("div")(() => ({
  fontFamily: "Manrope",
  fontSize: "16px",
  fontStyle: "normal",
  fontWeight: 400,
  lineHeight: "24px",
  letterSpacing: "0.5px",
  color: colors.gray600,
}));

export const Message = styled("span")(() => ({
  color: "#475467",
  fontFamily: "Manrope",
  fontSize: "14px",
  fontWeight: 400,
  lineHeight: "20px",
  letterSpacing: "0.25px",
}));
